/*
 * iurop-product — PDP Kawaicafe.
 *   · Galería: track deslizante con flechas (bucle), puntos y miniaturas sincronizadas.
 *   · Cantidad: botones −/+ (mín. 1).
 *   · Añadir al carrito (form y cross-sells): AJAX a /cart/add.js, re-render del
 *     sidecart vía Section Rendering API, actualiza [data-cart-count] y abre el
 *     drawer (mismos atributos que assets/global.js). Sin dependencias.
 */
(function () {
  'use strict';

  // ---- Carrito -------------------------------------------------------------
  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    document.documentElement.setAttribute('data-drawer-open', 'true');
  }

  function refreshCartDrawer() {
    // Re-render del sidecart con el carrito ya actualizado.
    return fetch(window.location.pathname + '?sections=iurop-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['iurop-cart-drawer'];
        var holder = document.getElementById('shopify-section-iurop-cart-drawer');
        if (html && holder) {
          var tpl = document.createElement('div');
          tpl.innerHTML = html;
          var fresh = tpl.querySelector('[data-cart-drawer]');
          var current = holder.querySelector('[data-cart-drawer]');
          if (fresh && current) current.replaceWith(fresh);
        }
      })
      .catch(function () { /* si falla, el carrito sigue OK en servidor */ });
  }

  function updateCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function afterAdd() {
    return Promise.all([refreshCartDrawer(), updateCartCount()])
      .then(openCartDrawer)
      .then(function () {
        // Contrato cross-agente: el side-cart re-arranca su temporizador de
        // reserva y sus flechas al oir esto. Sin el evento, el drawer recien
        // re-renderizado se quedaba con el reloj horneado en "10:00" (QA sidecart).
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { added: true } }));
      });
  }

  function withBusy(btn, promise, doneLabel) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.dataset.kpBusy = '1';
    return promise
      .then(function () {
        btn.textContent = doneLabel || original;
        setTimeout(function () { btn.textContent = original; }, 1600);
      })
      .catch(function (err) {
        btn.textContent = (err && err.description) ? 'Sin stock' : original;
        setTimeout(function () { btn.textContent = original; }, 2000);
      })
      .finally(function () {
        btn.disabled = false;
        delete btn.dataset.kpBusy;
      });
  }

  // ---- Galería ---------------------------------------------------------------
  function initGallery(root) {
    var track = root.querySelector('[data-kp-track]');
    if (!track) return null;
    var slideImgs = [].slice.call(track.querySelectorAll('.kawaii-pdp__slide-img'));
    var slides = track.children;
    var n = slides.length;
    var dots = root.querySelectorAll('[data-kp-dots] .kawaii-pdp__dot');
    var thumbs = root.querySelectorAll('[data-kp-thumbs] .kawaii-pdp__thumb');
    var thumbsWrap = root.querySelector('[data-kp-thumbs]');
    var mqThumbCenter = window.matchMedia('(max-width: 749px)');
    var active = 0;

    // Centra la miniatura activa en la tira (scroll nativo). Solo en móvil (<=749),
    // donde caben pocas y la activa se sale de vista al cambiar de imagen.
    function centerActiveThumb() {
      if (!thumbsWrap || !mqThumbCenter.matches) return;
      var el = thumbs[active];
      if (!el) return;
      var target = el.offsetLeft - (thumbsWrap.clientWidth - el.offsetWidth) / 2;
      var max = thumbsWrap.scrollWidth - thumbsWrap.clientWidth;
      target = Math.max(0, Math.min(target, max));
      // En pestaña oculta las animaciones de scroll no corren → salto directo
      // (permite verificar por código y evita quedarse a medias al volver).
      thumbsWrap.scrollTo({ left: target, behavior: document.hidden ? 'auto' : 'smooth' });
    }

    function render() {
      track.style.transform = 'translateX(' + (-100 * active) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === active); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === active); });
      centerActiveThumb();
    }
    function go(i) {
      active = ((i % n) + n) % n; // bucle
      render();
    }

    // Lightbox: clic en la foto del hero → galería a pantalla completa.
    initLightbox(root, slideImgs, function (i) { go(i); }, function () { return active; });

    if (n < 2) { render(); return { go: go, count: function () { return active; } }; }

    var prev = root.querySelector('[data-kp-prev]');
    var next = root.querySelector('[data-kp-next]');
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

    // Swipe táctil básico.
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(active + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    render();
    return { go: go, count: function () { return active; } };
  }

  // ---- Lightbox --------------------------------------------------------------
  // Al pulsar la imagen del hero se abre una galería a pantalla completa (overlay
  // en el <body> para vivir sobre todo). Prev/next, cuentakilómetros, teclado y
  // gestos; al cerrar sincroniza la galería con la última imagen vista.
  function initLightbox(root, slideImgs, syncTo, getActive) {
    if (root.dataset.kpLb || !slideImgs.length) return;
    root.dataset.kpLb = '1';
    var urls = slideImgs.map(function (img) { return img.getAttribute('data-kp-full') || img.currentSrc || img.src; });
    var alts = slideImgs.map(function (img) { return img.getAttribute('alt') || ''; });
    var n = urls.length;

    var lb = document.createElement('div');
    lb.className = 'kawaii-lightbox';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<div class="kawaii-lightbox__backdrop" data-lb-close></div>' +
      '<figure class="kawaii-lightbox__stage">' +
      '<img class="kawaii-lightbox__img" alt="">' +
      '</figure>' +
      '<button class="kawaii-lightbox__close" type="button" data-lb-close aria-label="Cerrar">&times;</button>' +
      (n > 1 ? '<button class="kawaii-lightbox__nav kawaii-lightbox__nav--prev" type="button" data-lb-prev aria-label="Anterior">&#8249;</button>' +
        '<button class="kawaii-lightbox__nav kawaii-lightbox__nav--next" type="button" data-lb-next aria-label="Siguiente">&#8250;</button>' +
        '<div class="kawaii-lightbox__count" data-lb-count></div>' : '');
    document.body.appendChild(lb);

    var img = lb.querySelector('.kawaii-lightbox__img');
    var counter = lb.querySelector('[data-lb-count]');
    var idx = 0;
    // Cache de descargas: sin esto cada `img.src = ...` disparaba una peticion
    // nueva de la foto grande y la siguiente imagen tardaba en aparecer.
    var cache = {};
    function preload(i) {
      var k = ((i % n) + n) % n;
      if (cache[k]) return;
      var im = new Image();
      im.decoding = 'async';
      im.src = urls[k];
      cache[k] = im;
    }

    function show(i) {
      idx = ((i % n) + n) % n;
      var destino = urls[idx];
      var ya = cache[idx];
      if (ya && ya.complete && ya.naturalWidth) {
        img.src = destino;
        lb.classList.remove('is-loading');
      } else {
        // La foto anterior sigue en pantalla hasta que la nueva esta lista:
        // asi no hay hueco en blanco mientras descarga.
        lb.classList.add('is-loading');
        var tmp = ya || new Image();
        tmp.decoding = 'async';
        tmp.onload = function () {
          if (urls[idx] === destino) { img.src = destino; lb.classList.remove('is-loading'); }
        };
        tmp.onerror = function () { img.src = destino; lb.classList.remove('is-loading'); };
        cache[idx] = tmp;
        if (!tmp.src) tmp.src = destino;
      }
      img.alt = alts[idx];
      if (counter) counter.textContent = (idx + 1) + ' / ' + n;
      // Vecinas por delante: al pasar ya estan en cache.
      preload(idx + 1);
      preload(idx - 1);
    }
    function open(i) {
      show(i);
      lb.classList.add('is-open');
      lb.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('kp-lb-open');
    }
    function close() {
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('kp-lb-open');
      if (syncTo) syncTo(idx); // la galería salta a la última vista
    }

    slideImgs.forEach(function (im, i) {
      im.style.cursor = 'zoom-in';
      im.addEventListener('click', function () { open(getActive ? getActive() : i); });
    });
    lb.querySelectorAll('[data-lb-close]').forEach(function (el) { el.addEventListener('click', close); });
    var p = lb.querySelector('[data-lb-prev]'); if (p) p.addEventListener('click', function () { show(idx - 1); });
    var nx = lb.querySelector('[data-lb-next]'); if (nx) nx.addEventListener('click', function () { show(idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
    // Gesto horizontal en el visor.
    var lx = null;
    lb.addEventListener('touchstart', function (e) { lx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (lx === null) return;
      var dx = e.changedTouches[0].clientX - lx;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      lx = null;
    }, { passive: true });
  }

  // ---- Sticky de la columna derecha: soltar donde ACABA EL HERO --------------
  // La info (dcha) es sticky dentro del contenedor, que es tan alto como la
  // columna izquierda (imagen principal + MINIATURAS). Para que la info se suelte
  // donde acaba la imagen del hero (no al final de las miniaturas), se añade a la
  // columna un margin-bottom = "lo que sobresale por debajo de la imagen". Se
  // recalcula en carga/resize; robusto para 1 sola imagen (margen 0) y N filas.
  function initStickyRelease(section) {
    var right = section.querySelector('.kawaii-pdp__right');
    var left = section.querySelector('.kawaii-pdp__left');
    var viewport = section.querySelector('.kawaii-pdp__viewport');
    if (!right || !left || !viewport) return;
    function adjust() {
      right.style.marginBottom = '0px';
      if (window.innerWidth < 990) return; // en móvil las columnas son display:contents
      var extra = Math.round(left.getBoundingClientRect().bottom - viewport.getBoundingClientRect().bottom);
      right.style.marginBottom = (extra > 0 ? extra : 0) + 'px';
    }
    adjust();
    window.addEventListener('load', adjust);
    window.addEventListener('resize', adjust);
    // Las imágenes cambian el alto al cargar → reajusta.
    section.querySelectorAll('.kawaii-pdp__slide-img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', adjust, { once: true });
    });
  }

  // ---- Init -------------------------------------------------------------------
  function init(section) {
    var gallery = section.querySelector('[data-kp-gallery]');
    if (gallery && !gallery.dataset.kpInit) {
      gallery.dataset.kpInit = '1';
      initGallery(gallery);
    }
    initStickyRelease(section);

    // Cantidad — puede haber 2 selectores (principal + barra fija), sincronizados.
    var qtyInputs = [].slice.call(section.querySelectorAll('[data-kp-qty]'));
    function curQty() { return qtyInputs[0] ? Math.max(1, +qtyInputs[0].value || 1) : 1; }
    // ---- Precio segun cantidad -------------------------------------------
    // El precio de la barra fija se quedaba clavado en el unitario y el boton no
    // decia lo que ibas a pagar (QA PDP). Se recalcula con el precio unitario en
    // centimos (data-kp-unit) y se formatea CALCANDO el formato que ya pinto
    // Liquid (separadores y posicion del simbolo), asi no hay que replicar aqui
    // el formato de moneda de la tienda ni depender de Intl.
    var priceNodes = [].slice.call(section.querySelectorAll('[data-kp-price]'));
    // Solo el boton PRINCIPAL lleva el total: la barra fija ya muestra el precio
    // recalculado junto al titulo y repetirlo ahi no cabia (206px de texto en un
    // boton de 253) ademas de decir dos veces la misma cifra.
    var addBtns = [].slice.call(section.querySelectorAll('[data-kp-add]'));
    var priceTpl = priceNodes.map(function (n) { return n.textContent.trim(); });

    function formatLike(sample, cents) {
      var m = sample.match(/[\d.,]+/);
      if (!m) return sample;
      var dec = m[0].lastIndexOf(',') > m[0].lastIndexOf('.') ? ',' : '.';
      var mil = dec === ',' ? '.' : ',';
      var val = (cents / 100).toFixed(2).split('.');
      var ent = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
      return sample.replace(/[\d.,]+/, ent + dec + val[1]);
    }

    function paintPrice(n) {
      // Los precios de la ficha y de la barra fija se quedan como estan: son el
      // precio POR UNIDAD (QA PDP). El total solo aparece en el boton de compra.
      var ref = priceNodes[0];
      var unit = ref ? parseInt(ref.getAttribute('data-kp-unit'), 10) : NaN;
      var total = isNaN(unit) ? '' : formatLike(priceTpl[0], unit * n);
      addBtns.forEach(function (b) {
        var base = b.getAttribute('data-kp-label');
        if (!base || b.disabled || b.dataset.kpBusy) return;
        b.textContent = n > 1 && total ? base + ' · ' + total : base;
      });
    }

    function setQty(v) {
      var n = Math.max(1, v | 0 || 1);
      qtyInputs.forEach(function (q) { q.value = n; });
      paintPrice(n);
    }
    section.querySelectorAll('[data-kp-minus]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(curQty() - 1); });
    });
    section.querySelectorAll('[data-kp-plus]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(curQty() + 1); });
    });
    qtyInputs.forEach(function (q) { q.addEventListener('change', function () { setQty(+q.value); }); });

    // Añadir al carrito (botón principal y barra fija comparten variante y cantidad).
    var form = section.querySelector('[data-kp-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    function doAdd(btn) {
      if (!btn || btn.dataset.kpBusy || !idInput) return;
      var original = btn.textContent;
      btn.dataset.kpBusy = '1';
      btn.disabled = true;
      addToCart([{ id: +idInput.value, quantity: curQty() }]).then(afterAdd)
        .then(function () {
          btn.textContent = '¡Añadido!';
          setTimeout(function () { btn.textContent = original; }, 1600);
        })
        .catch(function (err) {
          if (err && err.description) {
            // Error real del carrito (p. ej. sin stock): avisar sin recargar.
            btn.textContent = 'Sin stock';
            setTimeout(function () { btn.textContent = original; }, 2000);
          } else if (form) {
            // Fallo inesperado (red/AJAX/JS): envío NATIVO del formulario → el producto
            // se añade igual y lleva a /cart. Así el "añadir" nunca se queda en nada.
            form.submit();
          } else {
            btn.textContent = original;
          }
        })
        .finally(function () {
          btn.disabled = false;
          delete btn.dataset.kpBusy;
        });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        doAdd(form.querySelector('[data-kp-add]'));
      });
    }
    var stickyAdd = section.querySelector('[data-kp-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () { doAdd(stickyAdd); });
    paintPrice(curQty());

    // Barra fija flotante: visible DESDE que sales del hero de la PDP (esta sección
    // .kawaii-pdp) HASTA antes del footer. Se activa cuando el borde inferior del hero
    // sube a la parte alta del viewport (ya estás en las secciones de abajo) y se
    // oculta al asomar el footer. Histéresis para que no parpadee. Scroll + rAF
    // (IntersectionObserver no dispara fiable con el overflow:clip del ancestro).
    var sticky = section.querySelector('[data-kp-sticky]');
    if (sticky) {
      // CLAVE: la sección .kawaii-pdp tiene isolation:isolate (stacking context),
      // así que un fixed DENTRO de ella queda por debajo de las secciones
      // posteriores del DOM (Te puede gustar, redes) aunque tenga z-index alto.
      // Se mueve al <body> para que viva en la capa más exterior.
      document.querySelectorAll('body > [data-kp-sticky]').forEach(function (old) {
        if (old !== sticky) old.remove(); // restos de re-render del editor
      });
      if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
      var footer = document.querySelector('.kawaii-footer, .shopify-section-group-footer-group, #shopify-section-footer');
      var stuck = false;
      var ticking = false;
      var evalSticky = function () {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var heroBottom = section.getBoundingClientRect().bottom;
        // "Has salido del hero": su borde inferior ya está en la mitad alta del viewport.
        var pastHero = stuck ? (heroBottom < vh * 0.6) : (heroBottom < vh * 0.45);
        // "Se corta ANTES del footer": la barra flota abajo, así que se oculta en
        // cuanto el borde superior del footer asoma por la parte baja del viewport
        // (antes de solaparse). Histéresis de 40px para que no parpadee.
        var ft = footer ? footer.getBoundingClientRect().top : Infinity;
        var footerIn = stuck ? (ft < vh + 8) : (ft < vh + 48);
        var show = pastHero && !footerIn;
        if (show === stuck) return;
        stuck = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('sticky-atc-visible', show);
      };
      var onScroll = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(evalSticky); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      evalSticky();
    }

    // Cross-sells.
    section.querySelectorAll('[data-kp-xsell]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.kpBusy) return;
        withBusy(btn, addToCart([{ id: +btn.dataset.kpXsell, quantity: 1 }]).then(afterAdd), '✓');
      });
    });
  }

  function boot() {
    document.querySelectorAll('.kawaii-pdp').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.kawaii-pdp');
    if (s) init(s);
  });
})();
